module.exports = __webpack_public_path__ + "media/images/game_icon/en/VG0007-e8985cc5863857c97b97b5034ecb0cc6.png";